/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';

import { ApiDevice } from './Device';

export interface UserSignUpRequest {

    /**
     * User's email address
     */
    email?: string;

    /**
     * User's first name
     */
    first_name?: string;

    /**
     * User's last name
     */
    last_name?: string;

    /**
     * Source of this sign up for tracking purposes
     */
    source?: string;

    /**
     * Whether the source delivered a never before seen device
     */
    source_first_time?: boolean;

    /**
     * Username for chat and comments
     */
    username?: string;

    /**
     * User's desired password
     */
    password?: string;

    /**
     * User has opted into email marketing
     */
    email_marketing_optin?: boolean;

    /**
     * Device
     */
    device?: ApiDevice;

    /**
     * Zip code of the user
     */
    zip?: string;

    /**
     * Result of reCAPTCHA challenge
     */
    recaptcha_token?: string;

    /**
     * Indicating which app the user signed up with (web, ios, etc)
     */
    app?: string;

    /**
     * Indicating which path the user is signing up via
     */
    flow?: string;

}

@Model('UserSignUp')
export class ApiUserSignUp extends BaseModel implements UserSignUpRequest {

    /**
     * User's email address
     */
    
    
    email: string;

    /**
     * User's first name
     */
    
    
    first_name: string;

    /**
     * User's last name
     */
    
    
    last_name: string;

    /**
     * Source of this sign up for tracking purposes
     */
    
    
    source: string;

    /**
     * Whether the source delivered a never before seen device
     */
    
    
    source_first_time: boolean;

    /**
     * Username for chat and comments
     */
    
    
    username: string;

    /**
     * User's desired password
     */
    
    
    password: string;

    /**
     * User has opted into email marketing
     */
    
    
    email_marketing_optin: boolean;

    /**
     * Device
     */
    @Type('ApiDevice')
    @Expand()
    device: ApiDevice;

    /**
     * Zip code of the user
     */
    
    
    zip: string;

    /**
     * Result of reCAPTCHA challenge
     */
    
    
    recaptcha_token: string;

    /**
     * Indicating which app the user signed up with (web, ios, etc)
     */
    
    
    app: string;

    /**
     * Indicating which path the user is signing up via
     */
    
    
    flow: string;

}
